import { useState } from "react";
import { GUIDE } from "@/lib/guide";
import { BookOpen, Download, ChevronRight } from "lucide-react";

export default function Guide() {
  const [active, setActive] = useState(GUIDE[0].id);
  const backend = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="p-6 lg:p-8 max-w-[1200px]">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
        <div>
          <h1 className="font-heading text-3xl font-bold text-slate-100 flex items-center gap-3"><BookOpen className="w-7 h-7 text-cyan-400" /> Mode d'emploi</h1>
          <p className="text-sm text-slate-400 mt-1">Comment utiliser l'outil de prospection PC UP au quotidien.</p>
        </div>
        <a data-testid="guide-download-pdf" href={`${backend}/api/guide.pdf`} target="_blank" rel="noreferrer" className="px-4 py-2.5 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold text-sm flex items-center gap-2">
          <Download className="w-4 h-4" /> Télécharger en PDF
        </a>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[260px_1fr] gap-5">
        <nav className="space-y-1 lg:sticky lg:top-6 self-start">
          {GUIDE.map((s) => (
            <a key={s.id} href={`#${s.id}`} onClick={() => setActive(s.id)} data-testid={`guide-nav-${s.id}`} className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${active === s.id ? "bg-cyan-500/10 text-cyan-300 border border-cyan-500/30" : "text-slate-400 hover:text-slate-200 hover:bg-slate-800/60"}`}>
              <ChevronRight className="w-3.5 h-3.5 shrink-0" /> {s.title}
            </a>
          ))}
        </nav>
        <div className="space-y-5">
          {GUIDE.map((s) => (
            <section key={s.id} id={s.id} data-testid={`guide-section-${s.id}`} className="p-6 bg-[#121215] border border-slate-800/80 rounded-xl scroll-mt-6">
              <h2 className="font-heading text-lg font-semibold text-slate-100 mb-3">{s.title}</h2>
              <ul className="space-y-2.5">
                {s.items.map((it, i) => (
                  <li key={i} className="flex gap-3 text-sm text-slate-300 leading-relaxed"><span className="mt-2 w-1.5 h-1.5 rounded-full bg-cyan-400 shrink-0" />{it}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
